module.exports = __webpack_public_path__ + "img/littleImg06.251ed4a5.gif";